import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import dayjs from 'dayjs'
import ContentGuide from 'global/guides/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import { PencilIcon, Trash2Icon } from 'lucide-react'
import { Treinamento } from 'service/api'
import CheckboxCobranca from '../../CheckboxCobranca'
import PrazoHomologacao from './PrazoHomologacao'

const columns: GridColDefPro[] = [
    {
        field: 'data',
        headerName: 'Data',
        width: 160,
        type: 'datetime-local',
        valueFormatter: ({ value }) =>
            value ? dayjs(value).format('DD/MM/YYYY HH:mm') : '-',
    },
    {
        field: 'quemRecebeu',
        headerName: 'Quem recebeu',
        width: 240,
    },
    {
        field: 'usuarioId',
        headerName: 'Técnico responsável',
        width: 240,
        valueGetter: ({ row }) =>
            row.Usuario
                ? `${row.Usuario.nome} (${row.Usuario.email})`
                : `ID ${row.usuarioId}`,
    },
    {
        field: 'observacao',
        headerName: 'Observação',
        flex: 1,
        maxWidth: 300,
        valueGetter: ({ value }) => value || '',
    },
    {
        field: 'cobranca',
        headerName: 'Cobrança',
        width: 120,
        type: 'boolean',
        align: 'center',
        renderCell: CheckboxCobranca,
    },
    {
        ...optionsColumn,
        field: '__editar',
        renderCell: ({ id }) =>
            hasPermission(['update', 'Treinamentos'], () => (
                <IconButton title="Editar" href={`${id}/editar`}>
                    <PencilIcon />
                </IconButton>
            )),
    },
    {
        ...optionsColumn,
        field: '__excluir',
        renderCell: ({ id }) =>
            hasPermission(['delete', 'Treinamentos'], () => (
                <IconButton title="Excluir" href={`${id}/excluir`}>
                    <Trash2Icon className="text-error" />
                </IconButton>
            )),
    },
]

interface Props {
    data: Treinamento[]
    isLoading: boolean
    criadoEm?: string | Date
}

export default function GridTreinamentos({ data, isLoading, criadoEm }: Props) {
    return (
        <ContentGuide.DataGrid
            onAdd
            loading={isLoading}
            defaultPageSize={10}
            columns={columns}
            rows={data}
            components={{
                Footer: () => <PrazoHomologacao criadoEm={criadoEm} />,
            }}
            ToolbarProps={{
                exportButtonProps: {
                    fileName: 'exportacao-treinamentos',
                },
                showQuickFilter: true,
            }}
        />
    )
}
